import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import api, { num, money } from "@/lib/api";
import { Card, PageHeader, KPICard, HealthBadge } from "@/components/admin/ui";

export default function Performance() {
  const [cities, setCities] = useState([]);
  const [ov, setOv] = useState(null);
  useEffect(() => {
    api.get("/dashboard/cities").then((r) => setCities(r.data.items)).catch(() => {});
    api.get("/dashboard/overview").then((r) => setOv(r.data)).catch(() => {});
  }, []);
  const chart = [...cities].sort((a, b) => b.revenue - a.revenue).map((c) => ({ name: c.name, revenue: c.revenue, leads: c.leads }));

  return (
    <div className="space-y-6">
      <PageHeader title="Performance" subtitle="Roll-up of performance across cities. Configure targets in Settings." />
      {ov && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <KPICard label="Task Completion" value={`${ov.task_completion_pct}%`} accent="#10B981" />
          <KPICard label="Leads" value={num(ov.leads)} accent="#06B6D4" />
          <KPICard label="Meetings" value={num(ov.meetings)} accent="#8B5CF6" />
          <KPICard label="Revenue" value={money(ov.revenue)} accent="#1D4ED8" />
        </div>
      )}
      <Card className="p-5">
        <h3 className="font-head font-semibold text-white mb-4">Top performing cities · revenue</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chart}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
            <XAxis dataKey="name" stroke="#64748B" fontSize={10} interval={0} angle={-25} textAnchor="end" height={60} />
            <YAxis stroke="#64748B" fontSize={11} tickFormatter={(v) => money(v)} />
            <Tooltip formatter={(v) => money(v)} contentStyle={{ background: "#151D2A", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12 }} />
            <Bar dataKey="revenue" fill="#1D4ED8" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </Card>
      <Card className="p-5">
        <h3 className="font-head font-semibold text-white mb-4">City performance board</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {cities.map((c) => (
            <div key={c.city_id} className="p-4 rounded-lg bg-[#0B0F19] border border-white/10">
              <div className="flex items-center justify-between"><span className="font-semibold text-white">{c.name}</span><HealthBadge health={c.health} /></div>
              <div className="mt-3 grid grid-cols-2 gap-2 text-sm">
                <div className="text-slate-400">Completion <span className="font-mono-metric text-white block">{c.completion_rate}%</span></div>
                <div className="text-slate-400">Revenue <span className="font-mono-metric text-emerald-400 block">{money(c.revenue)}</span></div>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
